/**
 * Copyright (c) 2019-Present Syncari - All rights reserved.
 */
import cx from 'classnames';
import * as React from 'react';

import type { StepperProps } from '../../types';
import { StepperContext } from './context';
import Step from './Step';
import './Stepper.less';

interface StepperComponent extends React.ForwardRefExoticComponent<StepperProps & React.RefAttributes<HTMLDivElement>> {
  Step: typeof Step;
}

const Stepper = React.forwardRef<HTMLDivElement, StepperProps>(
  ({ current, direction = 'vertical', className, style, labelBackground = false, children }, ref) => {
    const steps = React.Children.toArray(children);

    return (
      <StepperContext.Provider value={{ current, direction, totalSteps: steps.length, labelBackground }}>
        <div
          ref={ref}
          className={cx(
            'stepper',
            `stepper--${direction}`,
            { 'stepper--label-background': labelBackground },
            className
          )}
          style={style}>
          {React.Children.map(children, (child, index) => {
            if (!React.isValidElement(child)) return null;
            return React.cloneElement(child as React.ReactElement<{ _index: number }>, { _index: index });
          })}
        </div>
      </StepperContext.Provider>
    );
  }
) as StepperComponent;

Stepper.displayName = 'Stepper';
Stepper.Step = Step;

export default Stepper;
